require(
  [
    'locationsInitializer',
  ]
);

define("nhs/views/BuilderShowCaseRedesign/ShowLocations", function(){});

